import { App } from 'vue'
import ArcoVue, { Message } from '@arco-design/web-vue'
import '@arco-design/web-vue/dist/arco.css'
import ArcoVueIcon from '@arco-design/web-vue/es/icon'

export default (app: App): void => {
  app.use(ArcoVue)
  app.use(ArcoVueIcon)
  app.config.globalProperties.$message = Message
}
